import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import Dashboard from '../views/DashboardView.vue'
import UserView from '../views/UserView.vue'
import ProfileView from '../views/ProfileView.vue'
import Authentication from './middleware/Authentication'
import SystemView from '../views/SystemView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      middleware: [Authentication]
    }
  },
  {
    path: '/dashboard/:deviceId',
    name: 'Dashboard Sensor',
    component: Dashboard,
    props: true,
    meta: {
      middleware: [Authentication]
    }
  },
  {
    path: '/user',
    name: 'User',
    component: UserView,
    meta: {
      middleware: [Authentication]
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: {
      middleware: [Authentication]
    }
  },
  {
    path: "/system",
    name: 'System',
    component: SystemView,
    meta:{
      middleware: [Authentication]
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const middleware = to.meta.middleware;
  const context = { to, from, next };
  // Check if no middlware on route
  if (!middleware) {
    return next();
  }

  middleware[0]({ ...context });
})

export default router
